import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import { lazy, Suspense } from "react";
import ErrorBoundary from "./components/ErrorBoundary";
import { LangProvider } from "@/lib/i18n";
import Home from "./pages/Home";

const Install = lazy(() => import("./pages/Install"));

function Router() {
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/install"}>
        <Suspense fallback={<div style={{ padding: 24 }}>…</div>}>
          <Install />
        </Suspense>
      </Route>
      <Route path={"/404"} component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <LangProvider>
        <Router />
      </LangProvider>
    </ErrorBoundary>
  );
}

export default App;
